/** True when a rich-text HTML string has no user-visible content. */
export function isRichTextEmpty(value: unknown): boolean {
  if (value == null) {
    return true;
  }
  const raw = String(value).trim();
  if (raw === '') {
    return true;
  }
  if (raw === '<p></p>' || raw === '<p><br></p>' || raw === '<p><br/></p>') {
    return true;
  }
  const textOnly = raw.replace(/<[^>]*>/g, '').trim();
  return textOnly === '';
}
